{
  "chapel": {
    "u0": -16,
    "chordU": 16,
    "vc": 39.5,
    "half": 4.5,
    "eaveY": 10.8,
    "ridgeY": 16.4,
    "apse": "flat"
  },
  "belfry": {
    "u": -8,
    "v": -38.5,
    "radius": 0.55,
    "foot": 12.1,
    "eaves": 14.6,
    "tip": 18.8
  },
  "ranges": [
    {
      "id": "rokin-range",
      "u": -14,
      "v": -2,
      "angleDeg": -90,
      "length": 72,
      "width": 6,
      "eaves": 8.8,
      "ridge": 13,
      "floors": 2,
      "bays": 14,
      "roof": "slate",
      "passage": 0,
      "windowRows": [
        {
          "sill": 1.2,
          "top": 3.3
        },
        {
          "sill": 4.7,
          "top": 7.4,
          "round": true
        }
      ],
      "roofGables": {
        "centres": [-29, -21, -13, -5, 3, 11, 19, 27],
        "halfWidth": 0.8,
        "v0": 0.9,
        "v1": 3,
        "eaves": 11.9,
        "ridge": 13.1,
        "sill": 9.8,
        "top": 10.9
      }
    },
    {
      "id": "nes-range",
      "u": 14,
      "v": -2,
      "angleDeg": 90,
      "length": 72,
      "width": 6,
      "eaves": 7.5,
      "ridge": 11.3,
      "floors": 2,
      "bays": 14,
      "roof": "slate",
      "passage": 3,
      "passageU": 2,
      "roofGables": {
        "centres": [-28, -19, -10, -1, 8, 17, 26],
        "halfWidth": 0.65,
        "v0": 0.9,
        "v1": 3,
        "eaves": 10.3,
        "ridge": 11.4,
        "sill": 8.6,
        "top": 9.6
      }
    },
    {
      "id": "southern-cross-range",
      "u": 0,
      "v": -38.5,
      "angleDeg": 0,
      "length": 32,
      "width": 7,
      "eaves": 8.2,
      "ridge": 12.6,
      "floors": 2,
      "bays": 7,
      "roof": "slate",
      "passage": 0
    }
  ],
  "court": {
    "u0": -10.7,
    "u1": 10.7,
    "v0": -34.7,
    "v1": 34.7
  },
  "green": {
    "u0": -8.4,
    "u1": 8.4,
    "v0": -31,
    "v1": 31
  },
  "note": "The 1538 painting guides the long open court, unequal Rokin and Nes ranges, roof gablets and southern roof needle. The chapel site south of the Kalfsvelsteeg is retained from the 1544 map and later site history; its pre-fire elevation and the exact relationship to the painted northern body remain provisional. The 1544 woodcut follows the 1541 fire and is not copied as an undamaged 1538 survey. The 1774 domestic facade and later Lakenhal alterations are excluded. All dimensions, roof heights, window rows, bays, gablet counts, belfry details, lawn boundary and the Nes passage are fitted estimates. The approximately 3100 square metre core does not establish the medieval property boundary or backdate the 3000 square metre area described for 1566. Individual room functions and hidden facades remain unresolved. No continuous public east Rokin quay, formal garden, trees or freestanding houses are invented inside this core."
}
